/**
 * lib.ts — Categoría "Librería" (10 productos demo).
 */
import { buildProduct } from "./_factory";
import type { Producto } from "@/types";

const CAT = {
  categoryId: "cat_lib",
  skuPrefix: "LIB",
  categoria: "Librería",
} as const;

export const cat_lib_products: Producto[] = [
  buildProduct({
    ...CAT,
    index: 0,
    nombre: "Cien Años de Soledad",
    marca: "Editorial Sudamericana",
    modelo: "Edición Conmemorativa",
    origen: "Colombia",
    costo: 35000,
    precio: 54900,
    stock: 40,
    stockMinimo: 10,
    stockMaximo: 80,
    unidad: "unidad",
    ubicacionFisica: "Estante L1, literatura",
    proveedor: "Penguin Random House",
    descripcionLarga:
      "Novela universal de Gabriel García Márquez. Edición conmemorativa tapa dura con prólogo y apíndices.",
    especificaciones: [
      { clave: "Páginas", valor: "496" },
      { clave: "Autor", valor: "García Márquez" },
    ],
    imageKeywords: ["novel", "gabriel-garcia-marquez", "colombian-literature"],
    color: "bg-amber-400",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 1,
    nombre: "Hábitos Atómicos",
    marca: "Diana",
    origen: "España",
    costo: 45000,
    precio: 69900,
    stock: 35,
    stockMinimo: 8,
    stockMaximo: 70,
    unidad: "unidad",
    ubicacionFisica: "Estante L2, autoayuda",
    proveedor: "Planeta Colombia",
    descripcionLarga:
      "Bestseller James Clear sobre cómo formar hábitos poderosos. Tapa blanda, 320 páginas.",
    especificaciones: [
      { clave: "Autor", valor: "James Clear" },
      { clave: "Páginas", valor: "320" },
    ],
    imageKeywords: ["atomic-habits", "self-help-book", "productivity"],
    color: "bg-green-600",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 2,
    nombre: "Harry Potter Piedra Filosofal",
    marca: "Salamandra",
    modelo: "Tapa dura",
    origen: "España",
    costo: 65000,
    precio: 99900,
    stock: 25,
    stockMinimo: 6,
    stockMaximo: 50,
    unidad: "unidad",
    ubicacionFisica: "Estante L3, infantil-juvenil",
    proveedor: "Planeta Colombia",
    descripcionLarga:
      "Primera novela saga Harry Potter de J.K. Rowling. Edición tapa dura ilustrada por Jim Kay.",
    especificaciones: [
      { clave: "Autor", valor: "J.K. Rowling" },
      { clave: "Formato", valor: "Tapa dura ilustrada" },
    ],
    imageKeywords: ["harry-potter", "fantasy-book", "jk-rowling"],
    color: "bg-red-700",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 3,
    nombre: "Diccionario Larousse Español",
    marca: "Larousse",
    origen: "México",
    costo: 55000,
    precio: 84900,
    stock: 20,
    stockMinimo: 5,
    stockMaximo: 40,
    unidad: "unidad",
    ubicacionFisica: "Estante L4, referencia",
    proveedor: "Larousse Colombia",
    descripcionLarga:
      "Diccionario enciclopédico Larousse. 90.000 voces, 5.000 ilustraciones, apíndices cultural y gramatical.",
    especificaciones: [
      { clave: "Voces", valor: "90.000" },
      { clave: "Formato", valor: "Tapa dura" },
    ],
    imageKeywords: ["dictionary", "spanish-dictionary", "larousse"],
    color: "bg-blue-700",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 4,
    nombre: "Agenda Ejecutiva 2026",
    marca: "Moleskine",
    modelo: "Classic 12M",
    origen: "Italia",
    costo: 85000,
    precio: 129000,
    stock: 30,
    stockMinimo: 8,
    stockMaximo: 60,
    unidad: "unidad",
    ubicacionFisica: "Estante L5",
    proveedor: "Moleskine Colombia",
    material: "Cuero sintético",
    colorProducto: "Negro",
    descripcionLarga:
      "Agenda Moleskine Classic 2026 formato semana vista. Tapa dura, banda elástica, marcapáginas.",
    especificaciones: [
      { clave: "Formato", valor: "Semana vista" },
      { clave: "Páginas", valor: "400" },
    ],
    imageKeywords: ["planner", "moleskine", "agenda"],
    color: "bg-slate-900",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 5,
    nombre: "Libro Colorear Adultos",
    marca: "Panini",
    modelo: "Mandalas Zen",
    origen: "Italia",
    costo: 22500,
    precio: 34900,
    stock: 45,
    stockMinimo: 10,
    stockMaximo: 90,
    unidad: "unidad",
    ubicacionFisica: "Estante L6, hobbies",
    proveedor: "Panini Colombia",
    descripcionLarga:
      "Libro 50 mandalas variadas para colorear adultos. Papel grueso anti-traspaso, reduce estrés.",
    especificaciones: [
      { clave: "Mandalas", valor: "50" },
      { clave: "Formato", valor: "A4" },
    ],
    imageKeywords: ["coloring-book", "mandala-book", "adult-coloring"],
    color: "bg-purple-500",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 6,
    nombre: "El Principito",
    marca: "Salamandra",
    origen: "España",
    costo: 25000,
    precio: 39900,
    stock: 50,
    stockMinimo: 12,
    stockMaximo: 100,
    unidad: "unidad",
    ubicacionFisica: "Estante L3",
    proveedor: "Planeta Colombia",
    descripcionLarga:
      "Clásico de Antoine de Saint-Exupéry. Edición tapa blanda con ilustraciones originales a color.",
    especificaciones: [
      { clave: "Autor", valor: "Saint-Exupéry" },
      { clave: "Páginas", valor: "96" },
    ],
    imageKeywords: ["little-prince", "classic-book", "childrens-literature"],
    color: "bg-blue-500",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 7,
    nombre: "Libro Recetas Cocina",
    marca: "Intermedio",
    modelo: "Cocina Colombiana",
    origen: "Colombia",
    costo: 65000,
    precio: 99900,
    stock: 25,
    stockMinimo: 6,
    stockMaximo: 50,
    unidad: "unidad",
    ubicacionFisica: "Estante L6",
    proveedor: "Editorial Intermedio",
    descripcionLarga:
      "Recetario con 200 platos tradicionales colombianos. Fotografías a color, paso a paso detallado.",
    especificaciones: [
      { clave: "Recetas", valor: "200" },
      { clave: "Formato", valor: "Tapa dura" },
    ],
    imageKeywords: ["cookbook", "colombian-recipes", "cuisine-book"],
    color: "bg-yellow-500",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 8,
    nombre: "Cuento Infantil Caperucita",
    marca: "Edebé",
    origen: "España",
    costo: 18500,
    precio: 28900,
    stock: 55,
    stockMinimo: 12,
    stockMaximo: 110,
    unidad: "unidad",
    ubicacionFisica: "Estante L3",
    proveedor: "Panamericana Editorial",
    descripcionLarga:
      "Cuento infantil Caperucita Roja clásico, ilustraciones a color. Tapa dura apta para lectura compartida.",
    especificaciones: [
      { clave: "Edad", valor: "3-7 años" },
      { clave: "Páginas", valor: "32" },
    ],
    imageKeywords: ["childrens-book", "fairytale", "picture-book"],
    color: "bg-red-600",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 9,
    nombre: "Cómic Spider-Man",
    marca: "Marvel",
    modelo: "Ultimate Spider-Man Vol.1",
    origen: "EE.UU.",
    costo: 38500,
    precio: 59900,
    stock: 30,
    stockMinimo: 8,
    stockMaximo: 60,
    unidad: "unidad",
    ubicacionFisica: "Estante L7",
    proveedor: "Panini Cómics",
    descripcionLarga:
      "Volumen 1 Ultimate Spider-Man Marvel. 180 páginas a color, tapa blanda, historia origen remasterizada.",
    especificaciones: [
      { clave: "Páginas", valor: "180" },
      { clave: "Editorial", valor: "Marvel" },
    ],
    imageKeywords: ["spiderman-comic", "marvel-comic", "graphic-novel"],
    color: "bg-red-600",
    shape: "square",
  }),
];
